import React from "react";


// country code component for displaying corresponding countries code
const SelectCountryCode = (props) => {
  const { countries,tab, name,select, options, onChange, value, onKeyPress,widthValue } = props;

  let countriesNew = JSON.parse(JSON.stringify(countries));
  delete countriesNew["IN"];
  const filter = options.filter((opt)=>{
    console.log(opt)
    return opt.countryName===select
  })

  
 
  return (
    <div>
      <select
        tabIndex={tab}
        onChange={onChange}
        style={{ height: "40px", marginTop: "5px", width: `${widthValue}` }}
        onKeyPress={onKeyPress}
        name={name}
        id={name}
        value={value}
      >
       { filter.length > 0 && filter.map((option) => {
          return (
         
            <option key={option.dialingCode} value={option.dialingCode}>
             + {option.dialingCode}
            </option>
          );
        })}



        
       
      </select>
    </div>
  );
};

export default SelectCountryCode;
